import connector from '@/utils/Connection'

export default {
  actions: {
    async getDoctors ({dispatch, commit}, {practiceId}) {
      const guestAccess = !connector.connected;
      const result = await connector.getDoctorList(practiceId, guestAccess);
      this.state.lastResponse = result;
      if (result.error == 0) {
        this.state.doctorList = result.data;
      }
      return result;
    }
  }
}